class VariantBadge extends HTMLElement {
  connectedCallback() {
    this.textEl = this.querySelector("[data-vb-text]");
    this.labels = this.readData();

    if (typeof subscribe === "function" && typeof PUB_SUB_EVENTS !== "undefined") {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event && event.data ? event.data.variant : null;
        if (variant && variant.id) this.render(variant.id);
      });
    }

    this.onVariantEvent = (event) => {
      const detail = event ? event.detail : null;
      const id = detail && detail.variant ? detail.variant.id : detail ? detail.id : null;
      if (id) this.render(id);
    };
    document.addEventListener("variant:change", this.onVariantEvent);
  }

  disconnectedCallback() {
    if (typeof this.unsubscribe === "function") this.unsubscribe();
    document.removeEventListener("variant:change", this.onVariantEvent);
  }

  readData() {
    const script = this.querySelector("[data-variant-badge-data]");
    if (!script) return {};
    try {
      return JSON.parse(script.textContent) || {};
    } catch (error) {
      return {};
    }
  }

  render(variantId) {
    if (!this.textEl) return;
    const label = (this.labels[String(variantId)] || "").trim();
    this.textEl.textContent = label;
    this.hidden = label.length === 0;
  }
}

if (!customElements.get("variant-badge")) {
  customElements.define("variant-badge", VariantBadge);
}
